import React from "react";
import BaseButton from "./BaseButton";
import { VerticalAlignBottomOutlined } from '@ant-design/icons';
import { checkPermissions } from "@comps/commonFunctions";

const BaseDownload = ({ modkey, permissionAction = "view", text, className, ...props }) => {
  if (modkey && !checkPermissions(modkey, permissionAction)) {
    return null;
  }

  const label = text || "Download Sample";

  return (
    <BaseButton
      { ...props }
      aria-label={ label }
      title={ label }
      notify={ { title: label } }
      className={ ["download-button", "toolbar-icon-button", className].filter(Boolean).join(" ") }
    >
      <VerticalAlignBottomOutlined className="download-button-icon" />
    </BaseButton>
  );
};

BaseDownload.displayName = "BaseDownload";

export default BaseDownload;
